import * as React from 'react'
import { Typography } from 'cs-kevlar-react'
import { AccessTime } from 'cs-kevlar-react/lib/es/icons'
import { IconText } from 'components'

interface DeviceActivationTimeSpanProps {
  pinExpiresOn: string | undefined
  pinUsed: boolean
  pinExpired: boolean
}

function padTwoZeroes(number: Number) {
  return number.toString().padStart(2, '0')
}

function calculateDateText(givenPinExpiresOn: string | undefined) {
  const pinExpiresOn = givenPinExpiresOn ? new Date(givenPinExpiresOn) : null

  if (pinExpiresOn) {
    const now = new Date()
    const unixTimeDifference = (pinExpiresOn.getTime() - now.getTime()) / 1000

    //Pin is actually expired if the time difference is less than zero
    if (unixTimeDifference < 0) return null

    const hours = Math.floor(unixTimeDifference / 3600)

    const minutes = Math.floor((unixTimeDifference % 3600) / 60)

    const seconds = Math.floor(unixTimeDifference % 60)

    return `${padTwoZeroes(hours)}:${padTwoZeroes(minutes)}:${padTwoZeroes(
      seconds,
    )}`
  }
  return null
}

export const DeviceActivationTimeSpan: React.FunctionComponent<DeviceActivationTimeSpanProps> = ({
  pinExpiresOn,
  pinUsed,
  pinExpired,
}) => {
  const dateText = calculateDateText(pinExpiresOn)

  if (dateText && !pinUsed && !pinExpired) {
    return <IconText icon={AccessTime} text={dateText} />
  }
  return <Typography />
}
